import { SButton, SDialogButton, SDialogTitle, SIconButton, SInputLabel, STitleContainer, STitleH3 } from './common/BCommonComponents';
import React, { useContext, useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, FormControl, Grid, IconButton, MenuItem, Paper, Select, Table, TableBody, TableContainer } from '@material-ui/core';
import { HeadCell, Order, STableCell, STableHeader, STablePaginationContainer, STableRow } from './common/ScrivaniaTable';
import {
	CausaInterruzioneCode,
	CausaInterruzioneName,
	InterruzioneDTO,
	InterruzioneStatus,
	InterruzioneType,
	InterruzioniFilterDTO,
	PuntoServizioDTO,
	TipoInterruzioneCode,
	TipoInterruzioneName,
	UserDTO,
	UserRole
} from './common/Dtos';
import { FaPauseCircle, FaPlayCircle, FaSearch, FaStopCircle } from 'react-icons/all';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import axios from 'axios';
import { toast } from 'react-toastify';
import TablePagination from '@material-ui/core/TablePagination';
import AuthContext from './auth/AuthContext';
import { dateTableFormat, dateToIso, secondsToHms } from './common/DateUtils';
import { DateTime } from 'luxon';
import RouteLeavingGuard from './RouteLivingGuard';
import { Location } from 'history';
import { KeyboardDatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import LuxonUtils from '@date-io/luxon';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { useNewStopwatch } from './customHooks/NewTimerHook';

export function getCausa(code: string) {
	switch (code) {
		case CausaInterruzioneCode.SISTEMI_KO:
			return CausaInterruzioneName.SISTEMI_KO;
		case CausaInterruzioneCode.RITARDO:
			return CausaInterruzioneName.RITARDO;
		case CausaInterruzioneCode.PAUSA:
			return CausaInterruzioneName.PAUSA;
		default:
			return "Non definito";
	}
}

export function getTipologia(code: string) {
	switch (code) {
		case TipoInterruzioneCode.DISSERVIZIO:
			return TipoInterruzioneName.DISSERVIZIO;
		case TipoInterruzioneCode.PERSONALE:
			return TipoInterruzioneName.PERSONALE;
		default:
			return "Non definito";
	}
}

export function Interruzioni() {
	const auth = useContext(AuthContext);
	const [openDialog, setOpenDialog] = useState<boolean>(false);
	const [interruzioneInCorso, setInterruzioneInCorso] = useState<string>('');
	const [operatori, setOperatori] = useState<UserDTO[]>([]);
	const [interruzioneType, setInterruzioneType] = useState<string>('');
	const [puntiServizioList, setPuntiServizioList] = useState<PuntoServizioDTO[]>([]);

	//Tabella interruzioni attive
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [totalRow, setTotalRow] = useState(0)
	const [order, setOrder] = useState<Order>('asc');
	const [orderBy, setOrderBy] = useState<string>('id');
	const [interruzioniWaitList, setInterruzioniWaitList] = useState<InterruzioneDTO[]>([]);

	//Tabella storico interruzioni
	const [endedPage, setEndedPage] = useState(0);
	const [endedRowsPerPage, setEndedRowsPerPage] = useState(5);
	const [endedTotalRow, setEndedTotalRow] = useState(0)
	const [endedOrder, setEndedOrder] = useState<Order>('asc');
	const [endedOrderBy, setEndedOrderBy] = useState<string>('id');
	const [interruzioniEndedList, setInterruzioniEndedList] = useState<InterruzioneDTO[]>([]);
	const [endedFilter, setEndedFilter] = useState<InterruzioniFilterDTO>({
		tipologiaInterruzione: 'ALL',
		causaInterruzione: 'ALL',
		date: '',
		operatore: 'ALL',
		puntoServizioId: 'ALL'
	});

	const headCells: HeadCell[] = (auth.state.roles && (auth.state.roles.indexOf(UserRole.SUPERVISOR) > -1
		|| auth.state.roles.indexOf(UserRole.RESPONSIBLE) > -1
		|| auth.state.roles.indexOf(UserRole.ADMIN) > -1)) ?
		[
			{id: 'tipologiaInterruzione', numeric: false, disablePadding: false, label: 'TIPOLOGIA', sortable: true},
			{id: 'causaInterruzione', numeric: false, disablePadding: true, label: 'CAUSA', sortable: true},
			{id: 'startDate', numeric: false, disablePadding: true, label: 'DATA', sortable: true},
			{id: 'operatore', numeric: false, disablePadding: true, label: 'OPERATORE', sortable: true},
			{id: 'puntoServizioName', numeric: false, disablePadding: true, label: 'PUNTO DI SERVIZIO', sortable: true},
			{id: 'timer', numeric: false, disablePadding: true, label: '', sortable: false}
		]
		:
		[
			{id: 'tipologiaInterruzione', numeric: false, disablePadding: false, label: 'TIPOLOGIA', sortable: true},
			{id: 'causaInterruzione', numeric: false, disablePadding: true, label: 'CAUSA', sortable: true},
			{id: 'startDate', numeric: false, disablePadding: true, label: 'DATA', sortable: true},
			{id: 'timer', numeric: false, disablePadding: true, label: '', sortable: false}
		];

	const headCellsEnded: HeadCell[] = (auth.state.roles && (auth.state.roles.indexOf(UserRole.SUPERVISOR) > -1
		|| auth.state.roles.indexOf(UserRole.RESPONSIBLE) > -1
		|| auth.state.roles.indexOf(UserRole.ADMIN) > -1)) ?
		[
			{id: 'tipologiaInterruzione', numeric: false, disablePadding: false, label: 'TIPOLOGIA', sortable: true},
			{id: 'causaInterruzione', numeric: false, disablePadding: true, label: 'CAUSA', sortable: true},
			{id: 'startDate', numeric: false, disablePadding: true, label: 'DATA', sortable: true},
			{id: 'operatore', numeric: false, disablePadding: true, label: 'OPERATORE', sortable: true},
			{id: 'puntoServizioName', numeric: false, disablePadding: true, label: 'PUNTO DI SERVIZIO', sortable: true},
			{id: 'duration', numeric: false, disablePadding: true, label: 'DURATA', sortable: true},
		]
		:
		[
			{id: 'tipologiaInterruzione', numeric: false, disablePadding: false, label: 'TIPOLOGIA', sortable: true},
			{id: 'causaInterruzione', numeric: false, disablePadding: true, label: 'CAUSA', sortable: true},
			{id: 'startDate', numeric: false, disablePadding: true, label: 'DATA', sortable: true},
			{id: 'puntoServizioName', numeric: false, disablePadding: true, label: 'PUNTO DI SERVIZIO', sortable: true},
			{id: 'duration', numeric: false, disablePadding: true, label: 'DURATA', sortable: true},
		];

	useEffect(() => {
		getUsers();
		getPuntiServizio();
	}, [auth]);

	useEffect(() => {
	}, [openDialog, interruzioniEndedList, interruzioniWaitList]);

	useEffect(() => {
		getWait();
	}, [page, rowsPerPage, order, orderBy]);

	useEffect(() => {
		getEnded();
	}, [endedPage, endedRowsPerPage, endedOrder, endedOrderBy]);


	useEffect(() => {
		if (interruzioneInCorso === '') {
			window.onbeforeunload = null;
		} else {
			window.onbeforeunload = (event: BeforeUnloadEvent) => {
				return "Attenzione! Interruzione in corso! Confermi di voler uscire dalla pagina?";
			}
		}
	}, [interruzioneInCorso]);

	const getPuntiServizio = () => {
		if (auth.state.roles && auth.state.roles.indexOf(UserRole.OPERATOR) > -1) {
			auth.state.axiosInstance?.get('/api/puntoServizio/punti_servizio_of_operatore/' + auth.state.id)
				.then(res => {
					setPuntiServizioList(res.data);
				}).catch(error => {
				toast.error('🛑 Errore durante il recupero dei Punti di Servizio!');
				console.log(error);
			});
		} else {
			auth.state.axiosInstance?.get('/api/puntoServizio/punto_servizio_by_cooperativa/' + auth.state.cooperativa + '?login=' + false)
				.then(res => {
					setPuntiServizioList(res.data)
				})
				.catch(error => {
					toast.error('🛑 Errore durante il recupero dei Punti di Servizio!');
					console.log(error);
				})
		}

	}

	const getUsers = () => {
		auth.state.axiosInstance?.get('/api/puntoServizio/utenti/' + auth.state.puntoServizioLogged?.id)
			.then(res => {
				setOperatori(res.data)
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero delle Prestazioni!');
				console.log(error);
			})
	}

	const getAll = () => {
		axios.all([
			auth.state.axiosInstance?.get('/api/interruzione/interruzioni/wait',
				{
					params: {
						page: page,
						size: rowsPerPage,
						sort: orderBy + ',' + order
					}
				}),
			auth.state.axiosInstance?.get('/api/interruzione/interruzioni/ended',
				{
					params: {
						tipologiaInterruzione: endedFilter.tipologiaInterruzione === 'ALL' ? '' : endedFilter.tipologiaInterruzione,
						causaInterruzione: endedFilter.causaInterruzione === 'ALL' ? '' : endedFilter.causaInterruzione,
						date: dateToIso(endedFilter.date),
						operatore: endedFilter.operatore === 'ALL' ? '' : endedFilter.operatore,
						puntoServizioId: endedFilter.puntoServizioId === 'ALL' ? '' : endedFilter.puntoServizioId,
						page: endedPage,
						size: endedRowsPerPage,
						sort: endedOrderBy + ',' + endedOrder
					}
				})
		])
			.then(axios.spread((res1, res2) => {
				setInterruzioniWaitList(res1?.data.content);
				setTotalRow(res1?.data.totalElements);
				setInterruzioniEndedList(res2?.data.content);
				setEndedTotalRow(res2?.data.totalElements);
			}));
	}

	const getWait = () => {
		auth.state.axiosInstance?.get('/api/interruzione/interruzioni/wait',
			{
				params: {
					page: page,
					size: rowsPerPage,
					sort: orderBy + ',' + order
				}
			})
			.then(res => {
				setInterruzioniWaitList(res.data.content);
				setTotalRow(res.data.totalElements);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero delle Interruzioni!');
				console.log(error);
			});
	}

	const getEnded = () => {
		auth.state.axiosInstance?.get('/api/interruzione/interruzioni/ended',
			{
				params: {
					tipologiaInterruzione: endedFilter.tipologiaInterruzione === 'ALL' ? '' : endedFilter.tipologiaInterruzione,
					causaInterruzione: endedFilter.causaInterruzione === 'ALL' ? '' : endedFilter.causaInterruzione,
					date: dateToIso(endedFilter.date),
					operatore: endedFilter.operatore === 'ALL' ? '' : endedFilter.operatore,
					puntoServizioId: endedFilter.puntoServizioId === 'ALL' ? '' : endedFilter.puntoServizioId,
					page: endedPage,
					size: endedRowsPerPage,
					sort: endedOrderBy + ',' + endedOrder
				}
			})
			.then(res => {
				setInterruzioniEndedList(res.data.content);
				setEndedTotalRow(res.data.totalElements);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero delle Interruzioni!');
				console.log(error);
			});
	}

	const updateInterruzione = (interruzione: InterruzioneDTO) => {
		auth.state.axiosInstance?.put('/api/interruzione/update/' + interruzione.id, interruzione)
			.then(res => {
				getAll();
			})
			.catch(error => {
				toast.error('🛑 Errore durante l\'operazione!');
				console.log(error);
			});
	}

	const handleIniziaInterrDialogOpen = () => {
		setInterruzioneType(InterruzioneType.INIT_INTERRUZ);
		setOpenDialog(true);
	};

	const handleRegistraInterrPassDialogOpen = () => {
		setInterruzioneType(InterruzioneType.REG_INTERRUZ_PASS);
		setOpenDialog(true);
	};

	const handleDialogClose = (newInterruzione?: InterruzioneDTO) => {
		setOpenDialog(false);
		if (newInterruzione) {
			const status = (newInterruzione.endDateTime !== null && newInterruzione.endDateTime !== '') ? InterruzioneStatus.ENDED : InterruzioneStatus.WAIT;
			newInterruzione.statusInterruzione = status;
			newInterruzione.startDateTime = dateToIso(interruzioneType === InterruzioneType.INIT_INTERRUZ ? DateTime.now().toISO() : newInterruzione.startDateTime);
			newInterruzione.endDateTime = dateToIso(newInterruzione.endDateTime);
			newInterruzione.puntoServizioId = auth.state.puntoServizioLogged ? auth.state.puntoServizioLogged.id : '';
			newInterruzione.cooperativa = auth.state.cooperativa ? auth.state.cooperativa : '';
			auth.state.axiosInstance?.post('/api/interruzione/insert', newInterruzione)
				.then(res => {
					getAll();
				})
				.catch(error => {
					toast.error('🛑 Errore durante il salvataggio dell\'interruzione!');
					console.log(error);
				});
		}
	};

	const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const handleChangePage = (event: unknown, newPage: number) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleEndedRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
		const isAsc = endedOrderBy === property && endedOrder === 'asc';
		setEndedOrder(isAsc ? 'desc' : 'asc');
		setEndedOrderBy(property);
	};

	const handleEndedChangePage = (event: unknown, newPage: number) => {
		setEndedPage(newPage);
	};

	const handleEndedChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setEndedRowsPerPage(parseInt(event.target.value, 10));
		setEndedPage(0);
	};

	const handleTipologiaChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newFilter: InterruzioniFilterDTO = {
			...endedFilter,
			tipologiaInterruzione: event.target.value as string
		}
		setEndedFilter(newFilter);
	};

	const handleCausaChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newFilter: InterruzioniFilterDTO = {
			...endedFilter,
			causaInterruzione: event.target.value as string,
		}
		setEndedFilter(newFilter);
	};

	const handleDataChange = (date: MaterialUiPickersDate, value?: string | null) => {
		const newFilter: InterruzioniFilterDTO = {
			...endedFilter,
			date: date ? date?.toString() : '',
		}
		setEndedFilter(newFilter);
	};

	const handleOperatoreChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newFilter: InterruzioniFilterDTO = {
			...endedFilter,
			operatore: event.target.value as string
		}
		setEndedFilter(newFilter);
	};

	const handlePuntoServizioChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newFilter: InterruzioniFilterDTO = {
			...endedFilter,
			puntoServizioId: event.target.value as string
		}
		setEndedFilter(newFilter);
	};

	const handleSearchClick = () => {
		getEnded();
	}

	const handleStartTimer = (interruzione: InterruzioneDTO) => {
		setInterruzioneInCorso(interruzione.id);
	}

	const handleStopTimer = (interruzione: InterruzioneDTO) => {
		setInterruzioneInCorso('');
		updateInterruzione(interruzione);
	}

	const handleEndInterruzione = (interruzione: InterruzioneDTO) => {
		interruzione.statusInterruzione = InterruzioneStatus.ENDED;
		setInterruzioneInCorso('');
		updateInterruzione(interruzione);
	}

	const shouldBlockNavigation = (location: Location): boolean => {
		return interruzioneInCorso !== '';
	}

	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				// margin: theme.spacing(1),
				width: '100%',
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);

	const navigate = (path: string) => {
		//nothing
	}

	const classes = useStyles();

	return (
		<div>
			<STitleContainer>
				<STitleH3>Interruzioni</STitleH3>
			</STitleContainer>
			<Grid container spacing={0} className="w-100 my-4">
				<Grid item xs={3} className="pr-2">
					<SButton className="mt-4 mb-3 w-100" onClick={handleIniziaInterrDialogOpen} disabled={interruzioneInCorso !== ''}>
						Inizia interruzione ora</SButton>
				</Grid>
				<Grid item xs={4} className="pl-2">
					<SButton className="mt-4 mb-3 w-100" onClick={handleRegistraInterrPassDialogOpen}>Registra Interruzione passata</SButton>
				</Grid>
			</Grid>
			<STitleContainer>
				<STitleH3>Interruzioni Attive</STitleH3>
			</STitleContainer>
			<Paper>
				<TableContainer>
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table">
						<STableHeader
							numSelected={0}
							order={order}
							orderBy={orderBy}
							onRequestSort={handleRequestSort}
							rowCount={totalRow}
							headCells={headCells}
							addCheckbox={false}
							bgcolor="primary"
							sortable={true}
							disableAction={interruzioneInCorso !== ''}
						/>
						<TableBody>
							{interruzioniWaitList &&
							interruzioniWaitList.map((row, index) => {
								return (
									<InterruzioneRow
										row={row}
										disabledTimer={interruzioneInCorso !== ''}
										onEndInterruzione={handleEndInterruzione}
										onStartTimer={handleStartTimer}
										onStopTimer={handleStopTimer}
										showTimer={auth.state.login === row.operatore}
									/>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
				<STablePaginationContainer disable={interruzioneInCorso !== ''}>
					<TablePagination
						rowsPerPageOptions={[5, 10, 25]}
						component="div"
						count={totalRow}
						rowsPerPage={rowsPerPage}
						page={page}
						onChangePage={handleChangePage}
						onChangeRowsPerPage={handleChangeRowsPerPage}
						labelRowsPerPage={"Risultati per pagina"}
					/>
				</STablePaginationContainer>
			</Paper>

			<STitleContainer>
				<STitleH3>Storico Interruzioni</STitleH3>
			</STitleContainer>
			{auth.state.roles && (auth.state.roles.indexOf(UserRole.SUPERVISOR) > -1
				|| auth.state.roles.indexOf(UserRole.RESPONSIBLE) > -1
				|| auth.state.roles.indexOf(UserRole.ADMIN) > -1) &&
			<Grid container spacing={0} className="w-100 my-4">
				<Grid item xs={2} className="pr-2">
					<FormControl variant="outlined" className={classes.formControl}>
						<SInputLabel id="tipologia">Tipologia</SInputLabel>
						<Select
							required
							labelId="tipologia"
							id="tipologiaSelect"
							className={classes.selectEmpty}
							label="Tipologia"
							value={endedFilter.tipologiaInterruzione}
							onChange={handleTipologiaChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							<MenuItem value="ALL" key="ALL">TUTTI</MenuItem>
							<MenuItem value={TipoInterruzioneCode.PERSONALE} key={TipoInterruzioneCode.PERSONALE}>{TipoInterruzioneName.PERSONALE}</MenuItem>
							<MenuItem value={TipoInterruzioneCode.DISSERVIZIO} key={TipoInterruzioneCode.DISSERVIZIO}>{TipoInterruzioneName.DISSERVIZIO}</MenuItem>
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={2} className="pr-2">
					<FormControl variant="outlined" className={classes.formControl}>
						<SInputLabel id="causa">Causa</SInputLabel>
						<Select
							required
							labelId="causa"
							id="causaSelect"
							className={classes.selectEmpty}
							label="Causa"
							value={endedFilter.causaInterruzione}
							onChange={handleCausaChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							<MenuItem value="ALL" key="ALL">TUTTI</MenuItem>
							<MenuItem value={CausaInterruzioneCode.PAUSA} key={CausaInterruzioneCode.PAUSA}>{CausaInterruzioneName.PAUSA}</MenuItem>
							<MenuItem value={CausaInterruzioneCode.RITARDO} key={CausaInterruzioneCode.RITARDO}>{CausaInterruzioneName.RITARDO}</MenuItem>
							<MenuItem value={CausaInterruzioneCode.SISTEMI_KO} key={CausaInterruzioneCode.SISTEMI_KO}>{CausaInterruzioneName.SISTEMI_KO}</MenuItem>
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={2} className="px-2">
					<MuiPickersUtilsProvider utils={LuxonUtils} locale="it-IT">
						<KeyboardDatePicker
							id="date"
							label="Seleziona Data"
							className="w-100"
							variant="inline"
							inputVariant="outlined"
							InputLabelProps={{shrink: true}}
							value={endedFilter.date}
							onChange={handleDataChange}
							format="dd/MM/yyyy"
							okLabel={true}
							error={false}
						/>
					</MuiPickersUtilsProvider>
				</Grid>
				<Grid item xs={2} className="pr-2">
					<FormControl variant="outlined" className={classes.formControl}>
						<SInputLabel id="canaleAccesso">Operatore</SInputLabel>
						<Select
							required
							labelId="operatore"
							id="operatoreSelect"
							className={classes.selectEmpty}
							label="Operatore"
							value={endedFilter.operatore}
							onChange={handleOperatoreChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							<MenuItem value={"ALL"} key={"ALL"}>TUTTI</MenuItem>
							{operatori && operatori.map(op => {
								return (
									<MenuItem value={op.login} key={op.login}>{op.login}</MenuItem>
								)
							})}
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={2} className="pr-2">
					<FormControl variant="outlined" className={classes.formControl}>
						<SInputLabel id="puntoServizio">Punto di Servizio</SInputLabel>
						<Select
							required
							labelId="puntoServizio"
							id="puntoServizioSelect"
							className={classes.selectEmpty}
							label="Punto di Servizio"
							value={endedFilter.puntoServizioId}
							onChange={handlePuntoServizioChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							<MenuItem value={"ALL"} key={"ALL"}>TUTTI</MenuItem>
							{puntiServizioList && puntiServizioList.map(op => {
								return (
									<MenuItem value={op.id} key={op.id}>{op.name}</MenuItem>
								)
							})}
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={2} className="pl-2 d-flex align-items-center">
					<SIconButton onClick={handleSearchClick}><FaSearch className="mx-1"/></SIconButton>
				</Grid>
			</Grid>
			}
			<Paper>
				<TableContainer>
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table">
						<STableHeader
							numSelected={0}
							order={endedOrder}
							orderBy={endedOrderBy}
							onRequestSort={handleEndedRequestSort}
							rowCount={endedTotalRow}
							headCells={headCellsEnded}
							addCheckbox={false}
							bgcolor="primary"
							sortable={true}
							disableAction={false}
						/>
						<TableBody>
							{interruzioniEndedList &&
							interruzioniEndedList.map((row, index) => {
								return (
									<STableRow
										hover
										tabIndex={-1}
										key={row.id}
									>
										<STableCell padding="default">{getTipologia(row.tipologiaInterruzione)}</STableCell>
										<STableCell padding="none">{getCausa(row.causaInterruzione)}</STableCell>
										<STableCell padding="none">{dateTableFormat(row.startDateTime)}</STableCell>
										{
											(auth.state.roles && (auth.state.roles.indexOf(UserRole.SUPERVISOR) > -1
												|| auth.state.roles.indexOf(UserRole.RESPONSIBLE) > -1
												|| auth.state.roles.indexOf(UserRole.ADMIN) > -1)) &&
											<STableCell padding="none">{row.operatore}</STableCell>
										}
										<STableCell padding="none">{row.puntoServizioName}</STableCell>
										<STableCell padding="none">{secondsToHms(row.duration)}</STableCell>
									</STableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25]}
					component="div"
					count={endedTotalRow}
					rowsPerPage={endedRowsPerPage}
					page={endedPage}
					onChangePage={handleEndedChangePage}
					onChangeRowsPerPage={handleEndedChangeRowsPerPage}
					labelRowsPerPage={"Risultati per pagina"}
				/>
			</Paper>
			<InsertDialog open={openDialog} onClose={handleDialogClose} type={interruzioneType}/>
			<RouteLeavingGuard
				when={true}
				navigate={navigate}
				shouldBlockNavigation={shouldBlockNavigation}
				message={"Prima di uscire dalla pagina concludere o mettere in pausa l'interruzione!"}
			/>
		</div>
	)
}

interface InterruzioneRowProps {
	row: InterruzioneDTO;
	onEndInterruzione: (interruzione: InterruzioneDTO) => void;
	onStartTimer: (interruzione: InterruzioneDTO) => void;
	onStopTimer: (interruzione: InterruzioneDTO) => void;
	disabledTimer: boolean;
	showTimer: boolean;
}

function InterruzioneRow(props: InterruzioneRowProps) {
	const auth = useContext(AuthContext);
	const {row, onEndInterruzione, onStartTimer, onStopTimer, disabledTimer, showTimer} = props;
	// const {
	// 	isRunning,
	// 	elapsedTime,
	// 	startTimer,
	// 	stopTimer
	// } = useStopwatch(row.duration ? row.duration : 0);

	const {
		isRunning,
		elapsedTime,
		startTimer,
		stopTimer,
	} = useNewStopwatch(row.duration ? row.duration : 0);

	const handleStartStop = () => {
		if (isRunning) {
			stopTimer();
			const a = elapsedTime.split(':');

			const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);

			const newInterruzione: InterruzioneDTO = {
				id: row.id,
				operatore: row.operatore,
				tipologiaInterruzione: row.tipologiaInterruzione,
				causaInterruzione: row.causaInterruzione,
				startDateTime: row.startDateTime,
				endDateTime: row.endDateTime,
				duration: seconds,
				statusInterruzione: row.statusInterruzione,
				createdBy: row.createdBy,
				createdDate: row.createdDate,
				lastModifiedBy: row.lastModifiedBy,
				lastModifiedDate: row.lastModifiedDate,
				puntoServizioId: row.puntoServizioId,
				cooperativa: row.cooperativa,
				puntoServizioName: row.puntoServizioName
			}
			onStopTimer(newInterruzione);
		} else {
			startTimer();
			onStartTimer(row);
		}
	};

	const handleEndInterruzione = () => {
		stopTimer();
		const a = elapsedTime.split(':');

		const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);

		const newInterruzione: InterruzioneDTO = {
			id: row.id,
			operatore: row.operatore,
			tipologiaInterruzione: row.tipologiaInterruzione,
			causaInterruzione: row.causaInterruzione,
			startDateTime: row.startDateTime,
			endDateTime: row.endDateTime,
			duration: seconds,
			statusInterruzione: InterruzioneStatus.ENDED,
			createdBy: row.createdBy,
			createdDate: row.createdDate,
			lastModifiedBy: row.lastModifiedBy,
			lastModifiedDate: row.lastModifiedDate,
			puntoServizioId: row.puntoServizioId,
			cooperativa: row.cooperativa,
			puntoServizioName: row.puntoServizioName
		}
		onEndInterruzione(newInterruzione);
	};

	return (
		<React.Fragment>
			<STableRow
				hover
				tabIndex={-1}
				key={row.id}
			>
				<STableCell padding="default">{getTipologia(row.tipologiaInterruzione)}</STableCell>
				<STableCell padding="none">{getCausa(row.causaInterruzione)}</STableCell>
				<STableCell padding="none">{dateTableFormat(row.startDateTime)}</STableCell>
				{
					(auth.state.roles && (auth.state.roles.indexOf(UserRole.SUPERVISOR) > -1
						|| auth.state.roles.indexOf(UserRole.RESPONSIBLE) > -1
						|| auth.state.roles.indexOf(UserRole.ADMIN) > -1)) &&
					<React.Fragment>
						<STableCell padding="none">{row.operatore}</STableCell>
						<STableCell padding="none">{row.puntoServizioName}</STableCell>
					</React.Fragment>
				}
				<STableCell padding="none">
					<div className="d-flex align-items-center">
						<span>{(row.statusInterruzione === InterruzioneStatus.WAIT) ? elapsedTime : new Date(row.duration * 1000).toISOString().substr(11, 8)}</span>
						{showTimer &&
						<React.Fragment>
							<IconButton
								onClick={handleStartStop}
								disabled={disabledTimer && !isRunning}
							>
								{isRunning ?
									<FaPauseCircle className="color-secondary" size={25}/>
									:
									<FaPlayCircle className={disabledTimer ? "color-secondary" : "color-green"} size={25}/>
								}
							</IconButton>
							<IconButton
								onClick={handleEndInterruzione}
								disabled={disabledTimer && !isRunning}
							>
								{isRunning &&
								<FaStopCircle className="text-danger" size={25}/>
								}
							</IconButton>
						</React.Fragment>
						}
					</div>
				</STableCell>
			</STableRow>
		</React.Fragment>
	)
}

interface DialogProps {
	open: boolean;
	onClose: (interruzione?: InterruzioneDTO) => void;
	type: string;
}

function InsertDialog(props: DialogProps) {
	const auth = useContext(AuthContext);
	const {onClose, open, type} = props;
	const [interruzione, setInterruzione] = useState<InterruzioneDTO>({
		id: '',
		operatore: '',
		tipologiaInterruzione: '',
		causaInterruzione: '',
		startDateTime: '',
		endDateTime: '',
		duration: 0,
		statusInterruzione: '',
		createdBy: '',
		createdDate: '',
		lastModifiedBy: '',
		lastModifiedDate: '',
		puntoServizioId: auth.state.puntoServizioLogged ? auth.state.puntoServizioLogged.id : '',
		cooperativa: auth.state.cooperativa ? auth.state.cooperativa : '',
		puntoServizioName: auth.state.puntoServizioLogged ? auth.state.puntoServizioLogged.name : ''
	})
	const [errorDataInizio, setErrorDataInizio] = useState<boolean>(false);
	const [errorDataFine, setErrorDataFine] = useState<boolean>(false);
	const [errorTipo, setErrorTipo] = useState<boolean>(false);
	const [errorCausa, setErrorCausa] = useState<boolean>(false);
	const [hideText, setHideText] = useState<boolean>(true);

	useEffect(() => {
	}, [interruzione, hideText]);

	useEffect(() => {
		setInterruzione({
			id: '',
			operatore: '',
			tipologiaInterruzione: '',
			causaInterruzione: '',
			startDateTime: '',
			endDateTime: '',
			duration: 0,
			statusInterruzione: '',
			createdBy: '',
			createdDate: '',
			lastModifiedBy: '',
			lastModifiedDate: '',
			puntoServizioId: auth.state.puntoServizioLogged ? auth.state.puntoServizioLogged.id : '',
			cooperativa: auth.state.cooperativa ? auth.state.cooperativa : '',
			puntoServizioName: auth.state.puntoServizioLogged ? auth.state.puntoServizioLogged.name : ''
		});
		setErrorDataInizio(false);
		setErrorDataFine(false);
		setErrorTipo(false);
		setErrorCausa(false);
	}, [open]);

	const handleConferma = () => {
		if ((type === InterruzioneType.REG_INTERRUZ_PASS && interruzione.startDateTime === '')
			|| (type === InterruzioneType.REG_INTERRUZ_PASS && interruzione.endDateTime === '')
			|| interruzione.causaInterruzione === ''
			|| interruzione.tipologiaInterruzione === '') {
			setErrorDataInizio(type === InterruzioneType.REG_INTERRUZ_PASS && interruzione.startDateTime === '');
			setErrorDataFine(type === InterruzioneType.REG_INTERRUZ_PASS && interruzione.endDateTime === '');
			setErrorTipo(interruzione.tipologiaInterruzione === '');
			setErrorCausa(interruzione.causaInterruzione === '');
		} else {
			onClose(interruzione);
		}
	};

	const handleClose = () => {
		onClose();
	}

	const handleDataInizioChange = (date: MaterialUiPickersDate, value?: string | null) => {
		if (date && date.isValid) {
			const newInt = {
				...interruzione,
				startDateTime: date ? date?.toString() : ''
			}
			setInterruzione(newInt);
		}
	};

	const handleDataFineChange = (date: MaterialUiPickersDate, value?: string | null) => {
		if (date && date.isValid) {
			const newInt = {
				...interruzione,
				endDateTime: date ? date?.toString() : '',
			}
			setInterruzione(newInt);
		}
	};

	const handleDialogTipologiaChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newInt = {
			...interruzione,
			tipologiaInterruzione: event.target.value as string,
		}
		setInterruzione(newInt);
	};

	const handleDialogCausaChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newInt = {
			...interruzione,
			causaInterruzione: event.target.value as string,
		}
		setInterruzione(newInt);

		if (newInt.causaInterruzione.toLowerCase() === 'altro') {
			setHideText(false);
		} else {
			setHideText(true);
		}
	};

	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				// margin: theme.spacing(1),
				width: '100%',
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);

	const classes = useStyles();

	return (
		<Dialog
			fullWidth={true}
			disableBackdropClick
			open={open}>
			<SDialogTitle className="pb-0" id="simple-dialog-title">NUOVA INTERRUZIONE</SDialogTitle>
			<DialogContent>
				{type === InterruzioneType.REG_INTERRUZ_PASS &&
				<Grid container spacing={0} className="w-100">
					<Grid item xs={6} className="pr-2">
						<MuiPickersUtilsProvider utils={LuxonUtils} locale="it-IT">
							<KeyboardDateTimePicker
								id="dataInizio"
								label="Data Inizio"
								defaultValue={''}
								className="w-100"
								variant="inline"
								inputVariant="outlined"
								InputLabelProps={{shrink: true}}
								value={interruzione.startDateTime ? interruzione.startDateTime : ''}
								maxDate={new Date(interruzione.endDateTime)}
								ampm={false}
								onChange={handleDataInizioChange}
								error={errorDataInizio}
								format="dd/MM/yyyy HH:mm"
								required={true}
								okLabel={true}
								placeholder="gg/mm/aaaa hh:mm"
							/>
						</MuiPickersUtilsProvider>
					</Grid>
					<Grid item xs={6} className="pr-2">
						<MuiPickersUtilsProvider utils={LuxonUtils} locale="it-IT">
							<KeyboardDateTimePicker
								id="dataFine"
								label="Data Fine"
								defaultValue={''}
								className="w-100"
								variant="inline"
								inputVariant="outlined"
								InputLabelProps={{shrink: true}}
								value={interruzione.endDateTime ? interruzione.endDateTime : ''}
								minDate={new Date(interruzione.startDateTime)}
								ampm={false}
								onChange={handleDataFineChange}
								error={errorDataFine}
								format="dd/MM/yyyy HH:mm"
								required={true}
								okLabel={true}
								placeholder="gg/mm/aaaa hh:mm"
							/>
						</MuiPickersUtilsProvider>
					</Grid>
				</Grid>
				}
				<Grid container spacing={0} className="w-100 mt-3">
					<Grid item xs={6} className="pr-2">
						<FormControl variant="outlined" className={classes.formControl} error={errorTipo} required={true}>
							<SInputLabel id="tipologia">Tipologia</SInputLabel>
							<Select
								required
								labelId="tipologia"
								id="tipologiaSelect"
								className={classes.selectEmpty}
								label="Tipologia"
								value={interruzione.tipologiaInterruzione}
								onChange={handleDialogTipologiaChange}
								MenuProps={{
									anchorOrigin: {
										vertical: "bottom",
										horizontal: "left"
									},
									transformOrigin: {
										vertical: "top",
										horizontal: "left"
									},
									getContentAnchorEl: null
								}}
							>
								<MenuItem value={TipoInterruzioneCode.PERSONALE} key={TipoInterruzioneCode.PERSONALE}>{TipoInterruzioneName.PERSONALE}</MenuItem>
								<MenuItem value={TipoInterruzioneCode.DISSERVIZIO} key={TipoInterruzioneCode.DISSERVIZIO}>{TipoInterruzioneName.DISSERVIZIO}</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item xs={6} className="pr-2">
						<FormControl variant="outlined" className={classes.formControl} error={errorCausa} required={true}>
							<SInputLabel id="tipologia">Causa</SInputLabel>
							<Select
								required
								labelId="causa"
								id="causaSelect"
								className={classes.selectEmpty}
								label="Causa"
								value={interruzione.causaInterruzione}
								onChange={handleDialogCausaChange}
								MenuProps={{
									anchorOrigin: {
										vertical: "bottom",
										horizontal: "left"
									},
									transformOrigin: {
										vertical: "top",
										horizontal: "left"
									},
									getContentAnchorEl: null
								}}
							>
								<MenuItem value={CausaInterruzioneCode.PAUSA} key={CausaInterruzioneCode.PAUSA}>{CausaInterruzioneName.PAUSA}</MenuItem>
								<MenuItem value={CausaInterruzioneCode.RITARDO} key={CausaInterruzioneCode.RITARDO}>{CausaInterruzioneName.RITARDO}</MenuItem>
								<MenuItem value={CausaInterruzioneCode.SISTEMI_KO} key={CausaInterruzioneCode.SISTEMI_KO}>{CausaInterruzioneName.SISTEMI_KO}</MenuItem>
							</Select>
						</FormControl>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions className="p-4">
				<SDialogButton className="float-right" onClick={handleConferma}>CONFERMA</SDialogButton>
				<SDialogButton className="float-right" variantcolor="secondary" onClick={handleClose}>ANNULLA</SDialogButton>
			</DialogActions>
		</Dialog>
	);
}
